import { badgeBlueprint } from "@made-people/blueprint-badge/blueprint";

badgeBlueprint.override({
  slots: {
    wrapper:
      "transform inline-block transition-all whitespace-nowrap rounded-md",
  },
  variants: {
    color: {
      red: {
        wrapper: "bg-sale-badge-bg text-sale-badge-text",
      },
      black: {
        wrapper: "bg-black text-white",
      },
      white: {
        wrapper: "bg-white text-black",
      },
    },
    size: {
      sm: {
        wrapper: "py-0.5 px-1 text-label-sm font-medium font-primary",
      },
      lg: {
        wrapper: "py-2 px-2 text-label-md font-medium font-primary",
      },
      md: {
        wrapper: "py-1 px-2 text-label-md font-medium font-primary",
      },
    },
  },
});
